import React from 'react';
import {Anchor, Box, Grid, Header, Heading, Paragraph, Text} from 'grommet';

export default function DataHolder() {
    return (
        <Box
            direction="column"
            justify="center"
            fill
        >
            <Box
                direction="column"
                justify="start"
                pad="medium"
                margin="large"
                elevation="medium"
                round="small"
                overflow="scroll"
                height="90%"
                // flex="grow"
                // alignSelf="stretch"
            >
                <Box
                    flex="grow"
                    overflow="scroll"
                >
                    <Box>
                        <Heading level={3}>Data Sources</Heading>
                        <Paragraph size="small" fill>This page provides a description of each variable included in the
                            interactive
                            maps and graphs, including their respective source(s). All data used in this global outlook
                            comes from existing sources; users should reference the original sources when incorporating
                            or discussing these data in their own work. Any questions or concerns regarding the data,
                            their attributes, or their methodology should be directed to the host(s) of the original
                            data.</Paragraph>
                    </Box>
                    <Box>
                        <Heading level={4}>Financial Data</Heading>
                        <Box background="light-2" pad="xsmall">
                            <Heading level={5} margin="none">
                                China finance commitments (US$m)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total amount of finance commitments extended by the China Development Bank and the
                                Export-Import Bank of China to each country during 2008-2019 – in US$ million.
                                Source: R. Ray, K. P. Gallagher, W. Kring, J. Pitts, B. A. Simmons (2020) “Geolocated
                                dataset of Chinese overseas development finance.” Global Development Policy Center,
                                Boston
                                University.
                                <Anchor
                                    href="https://osf.io/7wuxv"
                                    target="_blank"
                                    label={<Text color="blue" size="xsmall"><u>https://osf.io/7wuxv</u></Text>}/>
                            </Paragraph>

                            <Heading level={5} margin="none">
                                China finance commitments (% GDP)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total amount of finance commitments extended by the China Development Bank and the
                                Export-Import Bank of China to each country during 2008-2019 – represented as the
                                percent of
                                each country’s most recently reported Gross Domestic Product.
                                Source: R. Ray, K. P. Gallagher, W. Kring, J. Pitts, B. A. Simmons (2020) Geolocated
                                dataset
                                of Chinese overseas development finance. Global Development Policy Center, Boston
                                University. https://osf.io/7wuxv
                                Source: World Bank (2020) “World Development Indicators Database.” World Bank.
                                <Anchor
                                    href="https://datacatalog.worldbank.org/dataset/world-development-indicators"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://datacatalog.worldbank.org/dataset/world-development-indicators</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                All external debt (% GDP)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total outstanding external debt for each country as of 2018 – represented as the percent
                                of each country’s most recently reported Gross Domestic Product.
                                Source: World Bank (2020) “World Development Indicators Database.” World Bank.
                                <Anchor
                                    href="https://datacatalog.worldbank.org/dataset/world-development-indicators"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://datacatalog.worldbank.org/dataset/world-development-indicators</u></Text>}/>
                            </Paragraph>

                            <Heading level={5} margin="none">
                                China payments due in 2020 (US$m)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total amount of all official bilateral payments originally due to China by the end of
                                2020 for each DSSI country – in US$ million.
                                Source: World Bank (2020) “COVID-19 Debt Service Suspension Initiative.” World Bank.
                                <Anchor
                                    href="https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none" fill>
                                China payments due in 2020 (% bilateral payments)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total amount of all official bilateral payments originally due to China by the end of
                                2020 for each DSSI country – represented as the percent of all bilateral payments
                                originally due by the end of 2020 for each DSSI country.
                                Source: World Bank (2020) “COVID-19 Debt Service Suspension Initiative.” World Bank.
                                <Anchor
                                    href="https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none" fill>
                                China payments due in 2020 (% external payments)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Total amount of all official bilateral payments originally due to China by the end of
                                2020 for each DSSI country – represented as the percent of all external (bilateral and
                                multilateral) payments originally due by the end of 2020 for each DSSI country.
                                Source: World Bank (2020) “COVID-19 Debt Service Suspension Initiative.” World Bank.
                                <Anchor
                                    href="https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.worldbank.org/en/topic/debt/brief/covid-19-debt-service-suspension-initiative</u></Text>}/>
                            </Paragraph>
                        </Box>
                    </Box>
                    <Box>
                        <Heading level={4}>Environmental Data</Heading>
                        <Box background="light-2" pad="xsmall" overflow="scroll">

                            <Heading level={5} margin="none">
                                Annual carbon emissions (kt CO2)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Average annual carbon dioxide emissions during 2008-2016 for each country – in kt CO2
                                per year.
                                Source: World Bank (2020) “World Development Indicators Database.” World Bank.
                                <Anchor
                                    href="https://datacatalog.worldbank.org/dataset/world-development-indicators"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://datacatalog.worldbank.org/dataset/world-development-indicators</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Climate Vulnerability Index
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Index measuring the propensity or predisposition of human societies to be negatively
                                impacted by climate hazards for each country as of 2018.
                                Source: Notre Dame Global Adaptation Initiative (2020) “ND-GAIN Country Index.” ND-GAIN.
                                <Anchor
                                    href="https://gain.nd.edu/our-work/country-index"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://gain.nd.edu/our-work/country-index</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Forest area (sq. km)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Extent of forest area (30% canopy cover) for each country as of 2010 – in square
                                kilometers.
                                Source: Global Forest Watch (2020) “Global location of forest.” Global Forest Watch.
                                <Anchor
                                    href="https://www.globalforestwatch.org"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.globalforestwatch.org</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Annual tree cover loss (sq. km)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Average annual rate of tree cover loss between 2011-2019 for each country – in square
                                kilometers per year.
                                Source: Global Forest Watch (2020) “Global annual tree cover loss.” Global Forest Watch.
                                <Anchor
                                    href="https://www.globalforestwatch.org"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.globalforestwatch.org</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Annual tree cover loss (% 2010 extent)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Average annual rate of tree cover loss between 2011-2019 for each country – represented
                                as the percent of the country’s total forest area (30% canopy cover) in 2010.
                                Source: Global Forest Watch (2020) “Global location of forest.” Global Forest Watch.
                                https://www.globalforestwatch.org
                                Source: Global Forest Watch (2020) “Global annual tree cover loss.” Global Forest Watch.
                                <Anchor
                                    href="https://www.globalforestwatch.org"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.globalforestwatch.org</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Threatened species (total)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Number of vulnerable, endangered, or critically endangered mammals, amphibians,
                                reptiles, and birds with distribution ranges within each country.
                                Source: International union for the Conservation of Nature (2020) “The IUCN Red List of
                                Threatened Species.” Version 2020-1. IUCN. https://www.iucnredlist.org
                                Source: BirdLife International and Handbook of the Birds of the World (2020) “Bird
                                species distribution maps of the world.” Version 2020.1. BirdLife International.
                                <Anchor
                                    href="http://datazone.birdlife.org/species/requestdis"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>http://datazone.birdlife.org/species/requestdis</u></Text>}/>
                            </Paragraph>
                            <Heading level={5} margin="none">
                                Threatened species density (spp./sq. km)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Number of threatened species per square kilometer of the country’s terrestrial area
                                (spp./sq km).
                                Source: International union for the Conservation of Nature (2020) “The IUCN Red List of
                                Threatened Species.” Version 2020-1. IUCN.
                                <Anchor
                                    href="https://www.iucnredlist.org"
                                    target="_blank"
                                    label={<Text color="blue" size="xsmall"><u>https://www.iucnredlist.org</u></Text>}/>
                            </Paragraph>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Source: BirdLife International and Handbook of the Birds of the World (2020) “Bird
                                species distribution maps of the world.” Version 2020.1. BirdLife International.
                                <Anchor
                                    href="http://datazone.birdlife.org/species/requestdis"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>http://datazone.birdlife.org/species/requestdis</u></Text>}/>

                            </Paragraph>
                        </Box>
                    </Box>
                    <Box>
                        <Heading level={4}>Opportunity Data</Heading>
                        <Box background="light-2" pad="xsmall" overflow="scroll">
                            <Heading level={5} margin="none">
                                NDC renewable energy costs (US$m)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Estimated costs of each country’s nationally determined contributions (NDCs) to
                                renewable energy under the Paris Climate Agreement for solar PV, wind power, hydropower,
                                geothermal energy, electricity from bioenergy, and concentrating solar power – in US$
                                million.
                                Source: M. M. Cabré, K. P. Gallagher, Z. Li (2018) Renewable energy: the trillion dollar
                                opportunity for Chinese overseas investment. China and the World Economy 26: 27-49.
                            </Paragraph>
                            <Heading level={5} margin="none">
                                NDC renewable energy costs (% GDP)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Estimated costs of each country’s nationally determined contributions (NDCs) to
                                renewable energy under the Paris Climate Agreement for solar PV, wind power, hydropower,
                                geothermal energy, electricity from bioenergy, and concentrating solar power –
                                represented as the percent of each country’s most recently reported Gross Domestic
                                Product.
                                Source: M. M. Cabré, K. P. Gallagher, Z. Li (2018) Renewable energy: the trillion dollar
                                opportunity for Chinese overseas investment. China and the World Economy 26: 27-49.
                                Source: World Bank (2020) “World Development Indicators Database.” World Bank.
                                <Anchor
                                    href="https://datacatalog.worldbank.org/dataset/world-development-indicators"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://datacatalog.worldbank.org/dataset/world-development-indicators</u></Text>}/>
                            </Paragraph>

                            <Heading level={5} margin="none">
                                Remaining intact land (sq. km)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Extent of land with a human footprint score {"<"} 4 for each country as of 2013 – in
                                square kilometers.
                                Source: B. A. Williams et al. (2020) Change in terrestrial human footprint drives
                                continued loss of intact ecosystems. One Earth 3: 371-382.
                            </Paragraph>

                            <Heading level={5} margin="none">
                                Remaining intact land (% country)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Extent of land with a human footprint score {"<"} 4 for each country as of 2013 –
                                represented as the percent of each country’s terrestrial area.
                                Source: B. A. Williams et al. (2020) Change in terrestrial human footprint drives
                                continued loss of intact ecosystems. One Earth 3: 371-382.
                            </Paragraph>

                            <Heading level={5} margin="none">
                                Unprotected intact land (% intact land)
                            </Heading>
                            <Paragraph size="small" fill margin={{top: "none"}}>
                                Extent of land with a human footprint score {"<"} 4 for each country as of 2013 that is
                                outside regional, national, and international protected areas designated as of August
                                2020 – represented as the percent of each country’s remaining intact landscapes.
                                Source: B. A. Williams et al. (2020) Change in terrestrial human footprint drives
                                continued loss of intact ecosystems. One Earth 3: 371-382.
                                Source: UNEP-WCMC and IUCN (2020) “Protected Planet: the World Database on Protected
                                Areas.” Version August 2020. UNEP-WCMC and IUCN.
                                <Anchor
                                    href="https://www.protectedplanet.net"
                                    target="_blank"
                                    label={<Text color="blue"
                                                 size="xsmall"><u>https://www.protectedplanet.net</u></Text>}/>
                            </Paragraph>

                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
